import { Column, Table } from "react-migration/components/TableDeprecated";

import { Hatch } from "react-migration/domains/constraints/components/Hatch/Hatch";
import { SLOPE_CATEGORIES } from "../constants";
import { useMemo } from "react";

export function TopographySlopeMapLegend() {
  const slopeLegend = SLOPE_CATEGORIES.map(({ name, color, description }) => ({
    name,
    color,
    description,
  }));

  const columns = useMemo(() => {
    return [
      {
        label: "Category",
        grow: false,
        render: ({ color, name }) => (
          <div className="flex gap-2">
            <Hatch borderColor={color} fillColor={color} />
            <span>{name}</span>
          </div>
        ),
      },
      {
        label: "Gradient",
        render: ({ description }) => <span>{description}</span>,
      },
    ] as Column<(typeof slopeLegend)[number]>[];
  }, []);

  return (
    <Table
      primaryKey="name"
      columns={columns}
      rows={slopeLegend}
      size="small"
      hideHeader={true}
      highlightRowOnHover={false}
    />
  );
}
